import Vue from 'vue';

Vue.component( 'dialog-edicion', () => import( '@com/dialogs/dialog-edicion.vue' ) );
